// extracted by mini-css-extract-plugin
module.exports = {"cta":"_2eMhevmv","disabled":"K9j6gTi_","primary":"_3TLVDsPy","transparent":"_3JXr6VuA","secondary":"_1-dp7PA6","fullWidth":"_2P8v0le5","small":"_2vKQaT2A","spinner":"_1AYC6NG7"};